<template>
  <div class="main-wrapper">
    <roe-wizard-header
      title="Model Alternative Designs (Improving Behaviors)"
      :num="3"
    >
      <div class="header-sub-nav">
        <a href="#" class="nav-link active">Saving</a>
        <a href="#" class="nav-link ">Investing</a>
        <a href="#" class="nav-link ">Spending</a>

        <roe-plan-designs-minimized-checkbox></roe-plan-designs-minimized-checkbox>
      </div>
    </roe-wizard-header>

    <div class="content">
      <div class="scrollable-content">
        <div class="scrollable-content--width">
          <roe-independent-research-provides></roe-independent-research-provides>

          <roe-plan-designs-table></roe-plan-designs-table>

          <template v-if="calculated">
            <roe-participation-rate></roe-participation-rate>
            <roe-deferral-rate></roe-deferral-rate>
            <roe-maximizing-company-match></roe-maximizing-company-match>
            <roe-lag-indicators-balance-impact></roe-lag-indicators-balance-impact>
            <roe-marginal-cost></roe-marginal-cost>
            <roe-paycheck-impact></roe-paycheck-impact>
            <roe-paycheck-impact-percent></roe-paycheck-impact-percent>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import RoeWizardHeader from "@/components/layouts/WizardHeader";
import RoePlanDesignsTable from "@/components/alternative-designs/saving-behavior/PlanDesignsTable";
import RoeIndependentResearchProvides from "@/components/alternative-designs/saving-behavior/IndependentResearchProvides";
import RoeLagIndicatorsBalanceImpact from "@/components/alternative-designs/saving-behavior/LagIndicatorsBalanceImpact";
import { ALTERNATIVE_DESIGNS_FETCH } from "@/store/actions.type";
import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";
import { mapGetters } from "vuex";
import RoeMarginalCost from "@/components/alternative-designs/saving-behavior/MarginalCost";
import RoePaycheckImpact from "@/components/alternative-designs/saving-behavior/PaycheckImpact";
import RoePlanDesignsMinimizedCheckbox from "@/components/alternative-designs/_shared/PlanDesignsMinimizedCheckbox";
import RoeParticipationRate from "@/components/alternative-designs/saving-behavior/ParticipationRate";
import RoeDeferralRate from "@/components/alternative-designs/saving-behavior/DeferralRate";
import RoeMaximizingCompanyMatch from "@/components/alternative-designs/saving-behavior/MaximizingCompanyMatch";
import RoePaycheckImpactPercent from "@/components/alternative-designs/saving-behavior/PaycheckImpactPercent";

export default {
  name: "RoeReportAlternativeDesigns",
  components: {
    RoeMaximizingCompanyMatch,
    RoeDeferralRate,
    RoeParticipationRate,
    RoePlanDesignsMinimizedCheckbox,
    RoePaycheckImpact,
    RoePaycheckImpactPercent,
    RoeMarginalCost,
    RoeWizardHeader,
    RoePlanDesignsTable,
    RoeLagIndicatorsBalanceImpact,
    RoeIndependentResearchProvides
  },
  computed: {
    ...mapGetters(["calculated"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(ALTERNATIVE_DESIGNS_FETCH, to.params.id);
    store.commit(SET_INVALID_FORM_STATE, {
      errorMessage: "Please, calculate the data before continue"
    });
    return next();
  }
};
</script>
